import axios from 'axios';
import { forEach } from 'lodash';
//-- URL API
// http://floricents.dyndns.org:8080 <-- prod
// http://localhost:8080 <-- local
// 192.168.10.182
// ec2-54-80-76-93.compute-1.amazonaws.com <-- aws produccion
// 172.16.15.128 <-- vmserver

// const dominio = "floricents.dyndns.org";
const dominio = "https://floricents.dyndns.org:8082/"; //  "http://localhost:8080/";  // "http://ec2-3-132-141-153.us-east-2.compute.amazonaws.com:8080/";

// export const API_URL = `http://${dominio}:8080`;
// export const API_URL = `http://floricents.dyndns.org:8080`;
export const API_URL = `http://localhost:5000`

// -- URL del backend en PHP
// http://ec2-54-224-85-18.compute-1.amazonaws.com:8000/api/ <-- aws
// http://localhost:8000/api/ <-- local

export const BACK_URL = `${dominio}`;
export const PHP_API = `${dominio}api/`
export const PHP_BACK = `${dominio}`

// -- backend PHP
export const apiPhp = axios.create({
   baseURL: PHP_API,
});

export const backPHP = axios.create({
   baseURL: PHP_BACK,
});

// -- backend Php Sensores
export const apiPhpSensores = axios.create({
   baseURL: `http://${dominio}:8080/sensores/`,
});

export const apiNode = axios.create({
   baseURL: API_URL,
});


//"http://floricents.dyndns.org:8080"; //"http://localhost:8080";
export const IMG_URL = "http://floricents.dyndns.org/floricents_assets/img/";

export const getUser = () => {
   const usrStr = localStorage.getItem("user");
   let uris = localStorage.getItem("uris");
   if (usrStr) {
      let user = JSON.parse(usrStr);
      user.uris = JSON.parse(uris);
      return user;
   }
   else return null;
};



// return the token from the session storage
export const getToken = () => {
   return localStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
   // sessionStorage.removeItem('token');
   localStorage.removeItem("user");
   localStorage.removeItem("uris");
};

// set the token and user from the session storage
export const setUserSession = (user) => {
   // sessionStorage.setItem('token', token);
   localStorage.setItem("user", JSON.stringify(user));
   extractURIs(user);
};

export const check_uri_permission = (uri) => {
   let uris = localStorage.getItem("uris");

   if (!uris) return false;
   uris = JSON.parse(uris);

   for (let i = 0; i < uris.length; i++) {
      if (uris[i].uri.trim() === uri.trim()) return true;
   }
   return false;
}

const extractURIs = (user) => {
   let uris = [];
   if (!user || !user.menus) {
      localStorage.setItem("uris", JSON.stringify(uris));
      return;
   }

   user.menus.forEach(menu => {
      if (menu.url && menu.url !== '#') uris.push({ uri: menu.url, nombre: menu.nombre });
      if (menu.subMenus) {
         menu.subMenus.forEach(sub => {
            uris.push({ uri: sub.url, nombre: sub.nombre });
         });
      }
   });
   localStorage.setItem("uris", JSON.stringify(uris));
}

// --- numero de semana
export const getWeekNumber = (d, semanas = 0) => {
   if (!d) d = new Date();
   // Copy date so don't modify original
   d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate() + (semanas * 7)));
   // Set to nearest Thursday: current date + 4 - current day number
   // Make Sunday's day number 7
   d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
   // Get first day of year
   var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
   // Calculate full weeks to nearest Thursday
   var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
   // Return array of year and week number
   return [d.getUTCFullYear(), weekNo];
}

/**
 * cálculo de la semana
 * @param year
 * @param inicio
 * @param cantidad
 */
export const restarSemana = function (year, inicio, cantidad) {
   let semana = {
      nosemana: 0,
      year,
      cadena: "",
      success: true,
   };

   if (cantidad <= 52) {
      if (inicio < cantidad) {
         semana.nosemana = 52 - (cantidad - inicio);
         semana.year--;
         semana.cadena = semana.year + "" + (semana.nosemana + "").padStart(2, "0");
      } else {
         semana.nosemana = inicio - cantidad;
         if (semana.nosemana === 0) {
            semana.cadena = semana.year + "01";
         } else {
            semana.cadena = semana.year + "" + (semana.nosemana + "").padStart(2, "0");
         }
      }
   } //--  revisar que la cantidad no pase de 52
   else {
      semana.success = false;
   }

   return semana;
};

export const formatNumber = (number) => {
   const numberFormat = new Intl.NumberFormat('en-US');

   return numberFormat.format(number);
}

export const activeDialog = (setdialog, info, type = "error", head = "Ocurrió un problema") => {
   if (!setdialog) return;
   setdialog({
      tipo: type,
      show: true,
      title: head,
      body: info ?? "",
      funct: () => { setdialog({ show: false }) },
      size: 'm'
   })

}


export const dialogoConfirmacion = (setdialog, msj, funcion, btnYes = "Confirmar", btnNot = "Regresar") => {
   if (!funcion, msj == "" || !setdialog) return;
   setdialog({
      tipo: "error",
      show: true,
      title: "Confirme para continuar",
      body: msj,
      respYes: btnYes,
      respNot: btnNot,
      funct: (resp) => { if (resp) funcion(); setdialog({ show: false }) },
      size: 'm'
   })
}
